import { Component, OnDestroy, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { faArrowAltCircleLeft, faArrowAltCircleRight, faBell, faListAlt } from '@fortawesome/free-regular-svg-icons';
import { faBars, faBookReader, faBriefcase, faBuilding, faCaretDown, faCaretUp, faCog, faDatabase, faDesktop, faExternalLinkAlt, faHome, faImages, faInfinity, faLightbulb, faShoppingCart, faSignOutAlt, faSlidersH, faUser, faUserLock, faUsers, faWrench } from '@fortawesome/free-solid-svg-icons';
import { KYMW00Model } from '../commons/kymw00/kymw00.model';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FunctionMenuService } from '../commons/kymw02/function-menu/function-menu.service';
import { PlessDialogService } from '../shared/pless-dialog-service';
import { LogoutService } from './api-services/logout.service';
import { environment } from 'src/environments/environment';
import { GetInitTopModel } from './kymw10/kymw1001/vo/get-init-top.model';
import { LoginUserInfoService } from './kymw10/kymw1001/login-services/loginUserInfo.service';

@Component({
  selector: 'app-kymw',
  templateUrl: './kymw.component.html',
  styleUrls: ['./kymw.component.scss']
})
export class KYMWComponent implements OnInit, OnDestroy {

  @ViewChild('dashboard') dashBoardButton: ElementRef;

  /** @ignore メインメニューアイコン. */
  faBars = faBars;

  /** @ignore ダッシュボード画面用アイコン. */
  faHome = faHome;

  /** @ignore ジョブ一覧アイコン. */
  faListAlt = faListAlt;

  /** @ignore パスワード変更アイコン. */
  faUserLock = faUserLock;

  /** @ignore 管理アイコン. */
  faSlidersH = faSlidersH;

  /** @ignore お知らせ管理アイコン. */
  faBell = faBell;

  /** @ignore ユーザー管理アイコン. */
  faUser = faUser;

  /** @ignore ユーザーグループ管理アイコン. */
  faUsers = faUsers;

  /** @ignore メニュー全体開閉ボタンアイコン. */
  faArrowAltCircleLeft = faArrowAltCircleLeft;

  /** @ignore メニュー全体開閉ボタンアイコン. */
  faArrowAltCircleRight = faArrowAltCircleRight;

  /** @ignore 管理メニュー開閉アイコン. */
  faCaretUp = faCaretUp;

  /** @ignore 管理メニュー開閉アイコン. */
  faCaretDown = faCaretDown;

  /** @ignore アイコン. */
  faSignOutAlt = faSignOutAlt;

  /** @ignore アイコン. */
  faBuilding = faBuilding;

  /** @ignore アイコン. */
  faPopup = faExternalLinkAlt;

  /** タイトル. */
  mainTitle: string = null;

  /** バージョン情報 */
  versionInfo = '0.1.1';

  /** メインコンテンツ部分の現在のコンポーネント. */
  activeComponent: any;

  /** サンプルメッセージ */
  messages: string[] = [];


  /** タイトル. */
  title = 'タイトル';

  /** ユーザーグループ名（仮）.*/
  userGroupName = '第二営業部';

  /** ユーザー名（仮）.*/
  userName = '凸版太郎';

  /**  */
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    public sharedModel: KYMW00Model,
    private activatedRoute: ActivatedRoute,
    private fmenuService: FunctionMenuService,
    private dialogService: PlessDialogService,
    private logoutservice: LogoutService,
    private loginUserInfoService: LoginUserInfoService
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const snapshot = this.activatedRoute.snapshot;
        this.title = snapshot.firstChild.data.title;
        this.fmenuService.menus = [];
      }));
    this.title = this.activatedRoute.snapshot.firstChild.data.title;

    setInterval(() => {
      const uselessElements = document.querySelectorAll('[aria-hidden="true"]');
      uselessElements.forEach((element) => {
        element.setAttribute("aria-hidden", "false");
      });
    }, 5000);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  logout() {
    this.logoutservice.execute();
    this.router.navigate(['/login']);
    this.fmenuService.menus = [];
    this.sharedModel.kymw1001Model.loginUserInfo = new GetInitTopModel();
    this.loginUserInfoService.reset();
  }

  /**
   * キーダウンイベントハンドラ
   */
  @HostListener('document:keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    // Ctrl + M でメインメニューのダッシュボード画面にフォーカスを当てる
    if (event.ctrlKey && event.key === 'm') {
      event.preventDefault();
      this.dashBoardButton.nativeElement.focus();
    }
  }

  /**
   * ログアウトボタンの表示制御
   */
  logoutDisplaysHandler(event) {
    if (event === '1') {
      document.getElementById('logout_div').style.display = 'none';
    } else {
      document.getElementById('logout_div').style.display = '';
    }
  }

}
